import { combineReducers } from 'redux';

import { store as installations } from './installations';
import { store as oauth } from './oauth';
import { store as pullRequests } from './pullRequests';
import { store as organizations } from './organizations';
import { store as projects } from './projects';
import { store as reviews } from './reviews';
import { store as security } from './security';

export const store = combineReducers({
  installations,
  oauth,
  pullRequests,
  organizations,
  projects,
  reviews,
  security,
});
